import React from 'react';
import classNames from 'classnames';
import {Col, Container, Row} from 'reactstrap';
import './SectionCL.scss';

function AngleCL({
  angleType = 'slant',
  anglePosition = 'bottom',
  borderColor = 'white',
  color = 'black',
  className = undefined
}) {
  return (
    <div className={classNames(`angleWrap`, `angleCL-wrap-${anglePosition}`, className)}>
      {angleType === 'triangle' ? (
        <div className={classNames(`angleCL angleCL-${anglePosition}`)}>
          <svg className="fill-svg" viewBox="0 0 500 50" preserveAspectRatio="none">
            <polygon
              className={classNames(`fill-${color}`)}
              points={anglePosition === 'top' ? '0,500 0,0 250,30 500,0 500,500' : '0,0 250,30 500,0'}
            />
          </svg>
        </div>
      ) : (
        <>
          <div className={classNames(`angleCL angleCL-${anglePosition}`)}>
            <svg className="fill-svg" viewBox="0 0 500 50" preserveAspectRatio="none">
              <polygon
                className={classNames(`fill-${color}`)}
                points={anglePosition === 'top' ? '0,0 0,50 500,50 500,49' : '0,0 500,0 500,50 0,1'}
              />
            </svg>
          </div>
          <div className={classNames(`angleCL angleCL-${anglePosition}-border`)}>
            <svg className="fill-svg" viewBox="0 0 500 50" preserveAspectRatio="none">
              <polygon
                className={classNames(`fill-${borderColor}`)}
                points={anglePosition === 'top' ? '0,0 0,50 500,50 500,44' : '0,0 500,0 500,50 0,6'}
              />
            </svg>
          </div>
        </>
      )}
    </div>
  );
}

export default function SectionCL({
  id,
  color,
  borderColor = 'white',
  type = 'triangle',
  order = 'default',
  className = undefined,
  innerClass = undefined,
  innerWrapClass = undefined,
  imgUrl = undefined,
  imgDescription = undefined,
  imgPosition = undefined,
  imgBgPosition = 'center',
  imgBgClass = undefined,
  imgBgWrapClass = undefined,
  mobileImageHidden = false,
  colClass = undefined,
  angle = 'bottom',
  angleBottomDisplay = 'visible',
  children
}) {
  return (
    <section id={id} className={classNames(`sectionCL`, `background-${color}`, className)}>
      <div
        className={classNames(`sectionCL-inner-wrap`, `sectionCL-angleCL-bottom-${angleBottomDisplay}`, innerWrapClass)}
        style={{position: 'relative'}}
      >
        {imgPosition && imgUrl ? (
          <>
            <div className={classNames(`mobileImage`, mobileImageHidden && 'd-none')}>
              <img className="img-fill" alt={imgDescription ?? ''} src={imgUrl} />
            </div>

            <div className="sectionCL-image-wrap">
              <AngleCL
                anglePosition="top"
                color={color}
                borderColor={borderColor}
                className={classNames(mobileImageHidden && 'd-none', angle !== 'both' && 'd-lg-none')}
                angleType={type}
              />
              <div
                className={classNames(
                  `sectionCL-inner sectionCL-inner-image sectionCL-order-${order} sectionCL-angle-${angle}`,
                  innerClass,
                  mobileImageHidden && 'sectionCL-inner-image-mobile-hidden'
                )}
              >
                <Container style={{position: 'relative'}}>
                  <div className={classNames(`desktopImage`, `desktopImage-${imgPosition} text-${color}`)}>
                    <img className="img-fill desktop-image" alt={imgDescription ?? ''} src={imgUrl} />
                  </div>
                  <Row className={classNames(`d-flex justify-content-${imgPosition === 'left' ? 'end' : 'start'}`)}>
                    <Col className={classNames(colClass ? colClass : 'col-12 col-lg-7')}>{children}</Col>
                  </Row>
                </Container>
              </div>
              <AngleCL anglePosition="bottom" color={color} angleType={type} />
            </div>
          </>
        ) : (
          <>
            {angle === 'top' || angle === 'both' ? (
              <AngleCL anglePosition="top" color={color} borderColor={borderColor} angleType={type} />
            ) : null}
            {imgUrl && !imgPosition ? (
              <div
                className={classNames('sectionCL-background-image-wrap', imgBgWrapClass)}
                style={{position: 'absolute', clipPath: 'inset(0)'}}
              >
                <img
                  alt={imgDescription ?? ''}
                  src={imgUrl}
                  className={classNames('sectionCL-background-image', `img-fill`, imgBgClass)}
                />
              </div>
            ) : null}
            <div
              className={classNames(`sectionCL-inner sectionCL-order-${order} sectionCL-angle-${angle}`, innerClass)}
            >
              {children}
            </div>
            {angle === 'bottom' || angle === 'both' ? (
              <AngleCL anglePosition="bottom" color={color} borderColor={borderColor} angleType={type} />
            ) : null}
          </>
        )}
      </div>
    </section>
  );
}
